/**
 * Base protocol step types that are used across multiple files.
 * This file should have no internal dependencies to avoid circular imports.
 */

/**
 * The different kinds of protocol steps supported by the system.
 */
export enum IProtocolStepKind {
    EEG_SCAN = "eeg_scan",
    ECG_SCAN = "ecg_scan",
    NOTE = "note",  // deprecated in favor of note events.
    MEASURE_BP = "measure_bp",
    MEASURE_HR = "measure_hr",
    MEG_SCAN = "meg_scan",
    Q_AND_A = "q_and_a",
    QUESTIONNAIRE = "questionnaire",
    REST_EVENT = "rest_event",
    STIM_EVENT = "stim_event",
    START_DATA_COLLECTION = "start_data_collection",
    STOP_DATA_COLLECTION = "stop_data_collection",
    INSTRUCTIONS = "instructions",
    GROUP = "group",
    VAS_PAIN_SCORE = "vas_pain_score",
    NRS_PAIN_SCORE = "nrs_pain_score",
    PP_RELIEF = "pp_relief",
    MEASURE_PLR = "measure_plr",
    PORT_CONFIG = "port_config"
}

